<ng-container *ngIf="schemaInfo">
    <h6 class="text-secondary">Smart Micro anlernen</h6>
    <span *ngIf="localBusAddressSelect.length < 1" class="text-danger ms-2">Keine Sensoren gefunden!</span>
    <div *ngIf="localBusAddressSelect.length > 1" class="row">
        <div class="col-6">
            <div class="avs-test-area-additional-settings-w-2 mt-2 position-relative">
                <p class="mb-0 mt-3 text-secondary">Localbus-Adresse</p>
                <div [ngClass]="isLocalBusAddressDropdownOpen ? 'border-danger' : ''"
                    class="border d-flex justify-content-between" role="button" (click)="onLocalBusAddressDropdownClicked()">
                    <div class="ms-2 p-1">{{ selectedLocalBusAddress?.name ?? 'Localbus-Adresse' }}</div>
                    <img *ngIf="!isLocalBusAddressDropdownOpen" class="me-2" src="assets/icons/caret-down.svg"
                        alt="caret-down open select">
                    <img *ngIf="isLocalBusAddressDropdownOpen" class="me-2" src="assets/icons/caret-up.svg"
                        alt="caret-up close select">
                </div>
                <avs-dropdown [selectInput]="localBusAddressSelect" [activeItem]="selectedLocalBusAddress"
                    (onItemClicked)="onLocalBusAddressItemClicked($event)" [isHeaderActive]="false"
                    *ngIf="isLocalBusAddressDropdownOpen" class="avs-route-station-settings-dropdown-container">
                </avs-dropdown>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <div class="avs-test-area-additional-settings-w-2 mt-2 position-relative">
                <p class="mb-0 mt-3 text-secondary">Anlernen</p>
                <div [ngClass]="isLearningStatusDropdownOpen ? 'border-danger' : ''"
                    class="border d-flex justify-content-between" role="button" (click)="onLearningStatusDropdownClicked()">
                    <div class="ms-2 p-1">{{ selectedLearningStatus?.name ?? 'Status' }}</div>
                    <img *ngIf="!isLearningStatusDropdownOpen" class="me-2" src="assets/icons/caret-down.svg"
                        alt="caret-down open select">
                    <img *ngIf="isLearningStatusDropdownOpen" class="me-2" src="assets/icons/caret-up.svg"
                        alt="caret-up close select">
                </div>
                <avs-dropdown [selectInput]="statusSelect" [activeItem]="selectedLearningStatus"
                    (onItemClicked)="onLearningStatusItemClicked($event)" [isHeaderActive]="false"
                    *ngIf="isLearningStatusDropdownOpen" class="avs-route-station-settings-dropdown-container">
                </avs-dropdown>
            </div>
        </div>
        <div class="col-6 d-flex align-items-end">
            <button class="btn btn-outline-success rounded-0 avs-test-area-additional-settings-w-2"
                [disabled]="!selectedLocalBusAddress || !selectedLearningStatus" (click)="onLearnSaveBtnClicked()">Senden</button>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <div class="avs-test-area-additional-settings-w-2 mt-2 position-relative">
                <p class="mb-0 mt-3 text-secondary">App-Status</p>
                <div [ngClass]="isAppStatusDropdownOpen ? 'border-danger' : ''"
                    class="border d-flex justify-content-between" role="button" (click)="onAppStatusDropdownClicked()">
                    <div class="ms-2 p-1">{{ selectedAppStatus?.name ?? 'Status' }}</div>
                    <img *ngIf="!isAppStatusDropdownOpen" class="me-2" src="assets/icons/caret-down.svg"
                        alt="caret-down open select">
                    <img *ngIf="isAppStatusDropdownOpen" class="me-2" src="assets/icons/caret-up.svg"
                        alt="caret-up close select">
                </div>
                <avs-dropdown [selectInput]="statusSelect" [activeItem]="selectedAppStatus"
                    (onItemClicked)="onAppStatusItemClicked($event)" [isHeaderActive]="false"
                    *ngIf="isAppStatusDropdownOpen" class="avs-route-station-settings-dropdown-container">
                </avs-dropdown>
            </div>
        </div>
        <div class="col-6 d-flex align-items-end">
            <button class="btn btn-outline-success rounded-0 avs-test-area-additional-settings-w-2"
                [disabled]="!selectedLocalBusAddress || !selectedAppStatus" (click)="onAppStatusSaveBtnClicked()">Senden</button>
        </div>
    </div>
</ng-container>
